var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaffeWhite = function SvgCaffeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#caffe-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M1.5 14.25c.978.481 2.448.762 4.125.75 1.677.012 3.147-.269 4.125-.75s2.448-.762 4.125-.75c1.677-.012 3.147.269 4.125.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M12 1.5V6M7.5 1.5V6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M1.5 9H18v6.136a7.52 7.52 0 0 1-2.071 5.207c-1.326 1.381-3.125 2.157-5 2.157H8.57c-1.875 0-3.674-.776-5-2.157A7.52 7.52 0 0 1 1.5 15.136zM18 17.658c.473.256.991.371 1.51.336a2.85 2.85 0 0 0 1.468-.542c.444-.32.815-.764 1.08-1.292a4.3 4.3 0 0 0 .439-1.74 4.3 4.3 0 0 0-.304-1.78 3.7 3.7 0 0 0-.977-1.402 2.94 2.94 0 0 0-1.42-.696 2.7 2.7 0 0 0-1.53.172"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "caffe-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCaffeWhite;